export const LISTING_ROW_IMAGE_HEIGHT = 414
export const LISTING_ROW_IMAGE_WIDTH = 600

export const LOCATION_TBD = 'Location: TBD'
export const LOCATION = 'Location'
export const VENUE_TBD = 'Venue: TBD'
export const VENUE = 'Venue'
export const TBD = 'TBD'
export const TO_BE_DETERMINED = 'To Be Determined'
export const BULLET_SYMBOL = '\u2022'
